export function enumToOptions<T extends object>(
    e: T,
    getText?: (value: number, name: string) => string
): { value: number; text: string }[] {
    return Object.keys(e)
        .filter(k => isNaN(Number(k))) // only names, skip numeric keys from reverse mapping
        .map(name => {
            const value = (e as any)[name] as number;
            return { value, text: getText ? getText(value, name) : name };
        });
}